"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinishHiringProcessModal = void 0;
var FinishHiringProcessModal_1 = require("./FinishHiringProcessModal");
Object.defineProperty(exports, "FinishHiringProcessModal", { enumerable: true, get: function () { return FinishHiringProcessModal_1.FinishHiringProcessModal; } });
